(function () {
  function formatMoney(amount, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currency || 'USD'
    }).format(amount);
  }

  function initProductEdition() {
    var edition = document.querySelector('[data-product-edition]');
    if (!edition || edition.dataset.initialized === 'true') return;

    edition.dataset.initialized = 'true';
    var form = edition.closest('form');
    var variantInput = form && form.querySelector('[data-product-variant-id]');
    var price = document.querySelector('[data-product-price]');
    var addButton = form && form.querySelector('.product-add-to-cart');
    var quantityInput = form && form.querySelector('input[name="quantity"]');
    var quantityButtons = form ? Array.from(form.querySelectorAll('.product-quantity button')) : [];
    var details = Array.from(edition.querySelectorAll('[data-edition-detail]'));

    function update(choice) {
      if (!choice || !variantInput || !addButton) return;

      var choiceLabel = choice.closest('.product-edition__choice');
      var available = choice.dataset.variantAvailable === 'true';
      var unitPrice = parseFloat(choice.dataset.variantPrice);
      var currency = addButton.dataset.currency || 'USD';
      var isCollector = choiceLabel.querySelector('span').textContent.indexOf('Collector') !== -1;
      variantInput.value = choice.value;

      edition.querySelectorAll('.product-edition__choice').forEach(function (label) {
        label.classList.toggle('is-selected', label === choiceLabel);
      });
      details.forEach(function (detail) {
        detail.hidden = detail.dataset.editionDetail !== (isCollector ? 'collector' : 'reproduction');
      });

      if (quantityInput) {
        quantityInput.value = isCollector ? '1' : quantityInput.value;
        quantityInput.toggleAttribute('max', isCollector);
        if (isCollector) quantityInput.setAttribute('max', '1');
        quantityButtons.forEach(function (button) {
          button.disabled = isCollector;
        });
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (!Number.isNaN(unitPrice)) {
        if (price) price.textContent = formatMoney(unitPrice, currency);
        addButton.dataset.unitPrice = String(unitPrice);
      }

      addButton.disabled = !available;
      addButton.textContent = available
        ? (addButton.dataset.addToCartLabel || 'Add to Cart') + ' — ' + formatMoney(unitPrice, currency)
        : 'Sold Out';
      form.dispatchEvent(new CustomEvent('product:variant-change', {
        bubbles: true,
        detail: { price: unitPrice, available: available, variantId: choice.value }
      }));
    }

    edition.addEventListener('change', function (event) {
      if (event.target.matches('input[type="radio"]')) update(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductEdition);
  } else {
    initProductEdition();
  }
})();
